import type { Order, CheckoutCardSolidgate, CheckoutCardStripe, CheckoutSucceededData } from '@brighterly/lib-core-types/orders/interfaces'
import type { CheckoutCard, CheckoutResponseData } from '@brighterly/lib-core-types/orders/types'

export interface CheckoutResponseMap {
  order: Order
  solidgateData: CheckoutCardSolidgate | null
  stripeClientSecret: string | null
  paypalScriptUrl: string | null
  furtherPayments: string[]
  appliesForPromocode: boolean
  alreadySucceeded: boolean
}

const isStripeCard = (card: CheckoutCard): card is CheckoutCardStripe => 'client_secret' in card
const isSolidgateCard = (card: CheckoutCard): card is CheckoutCardSolidgate => 'merchant' in card && 'signature' in card

const isAlreadySucceeded = (data: CheckoutResponseData): data is CheckoutSucceededData => 'already_succeeded' in data

export const mapCheckoutResponse = (data: CheckoutResponseData): CheckoutResponseMap => {
  if (isAlreadySucceeded(data)) {
    return {
      order: data.order,
      solidgateData: null,
      stripeClientSecret: null,
      paypalScriptUrl: null,
      furtherPayments: [],
      appliesForPromocode: false,
      alreadySucceeded: true,
    }
  }

  const card = data.card

  return {
    order: data.order,
    solidgateData: card && isSolidgateCard(card) ? card : null,
    stripeClientSecret: card && isStripeCard(card) ? card.client_secret : null,
    paypalScriptUrl: data.paypal_script_url || null,
    furtherPayments: data.further_payments || [],
    appliesForPromocode: data.applies_for_promocode || false,
    alreadySucceeded: false,
  }
}
